import { createNavigationContainerRef } from "@react-navigation/native";

import { RootStackParamList } from "~/navigation/Navigation.types";

export const navigationRef = createNavigationContainerRef<RootStackParamList>();
